import type { QueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/shared/stores/auth.store';
import { useSecurityHandoff, type SecurityChange } from '@/shared/stores/security-handoff.store';

/** Called only after a successful credential mutation. Keep one-time response
 * data before clearing auth; the existing root guard then routes to public login.
 * clear() also triggers the registered IndexedDB purge and cross-tab logout. */
export function finishSecurityChange(queryClient: QueryClient, change: SecurityChange, backupCodes?: string[]): void {
  useSecurityHandoff.getState().prepare(change, backupCodes);
  useAuthStore.getState().clear();
  void queryClient.cancelQueries();
  queryClient.clear();
}
